'use client';

import React, { useState, useRef, useEffect } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import styles from './styles.module.scss';

const ResourcesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const dropdownRef = useRef(null);

  const resources = [
    {
      label: 'Free Tools',
      href: '/tools',
      description: 'Free AI-powered recruiting tools',
    },
    {
      label: 'Podcast',
      href: 'https://linktr.ee/alfiegwhattam',
      description: 'Interviews with leading AI experts',
    },
    {
      label: 'Blog',
      href: '/blog',
      description: 'Expert tips and hiring advice',
    },
    {
      label: 'Newsletter',
      href: 'https://codermagazine.substack.com/',
      description: 'Stay updated with recruiting insights',
    },
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', checkMobile);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setIsOpen(false);
    }
  };

  const handleClick = e => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${styles.dropdown} ${isMobile ? styles.mobileDropdown : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={e => e.stopPropagation()}
    >
      <div className={styles.trigger} onClick={handleClick}>
        <span>Resources</span>
        <MdOutlineKeyboardArrowDown
          className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}
          size={16}
        />
      </div>

      <div
        className={`${styles.menu} ${isOpen ? styles.menuVisible : styles.menuHidden} ${isMobile ? styles.mobileMenu : ''}`}
      >
        {resources.map((resource, index) => (
          <a
            key={index}
            href={resource.href}
            className={styles.item}
            target={resource.href.startsWith('http') ? '_blank' : undefined}
            rel={resource.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            onClick={() => setIsOpen(false)}
          >
            <div className={styles.itemLabel}>{resource.label}</div>
            <div className={styles.itemDescription}>{resource.description}</div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ResourcesDropdown;
